import React from 'react'

const SvgLinkedin = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width='14'
    height='14'
    viewBox='0 0 14 14'
    {...props}
  >
    <defs>
      <clipPath id='master_svg0_126_6139'>
        <rect x='0' y='0' width='14' height='14' rx='0' />
      </clipPath>
    </defs>
    <g clipPath='url(#master_svg0_126_6139)'>
      <g>
        <path
          d='M0.00043311,1.6629725C-0.0185133,2.4798225,0.585598,3.1434725,1.4896,3.1434725C2.43312,3.1434725,3.03831,2.4798225,3.03723,1.6629725C3.01936,0.8055245,2.4342,0.1640625,1.50854,0.1640625C0.585598,0.1640625,-0.0185133,0.8055245,0.00043311,1.6629725ZM0.075676,13.8344625L2.94412,13.8344625L2.94412,4.3105625L0.075676,4.3105625L0.075676,13.8344625ZM5.17002,4.3105625C5.20791,5.1496025,5.24635,6.1624025,5.24635,7.3500625L5.24635,13.8355625L8.11371,13.8355625L8.11371,8.3439225C8.11371,8.0716325,8.1516,7.7793225,8.22684,7.6033925C8.41685,7.0599125,8.88725,6.4926125,9.68028,6.4926125C10.7185,6.4926125,11.1326,7.3321925,11.1326,8.5582825L11.1326,13.8355625L14,13.8355625L13.9989,8.1874825C13.9989,5.3834525,12.5845,4.0961925,10.6985,4.0961925C9.16928,4.0961925,8.22576,5.0142725,7.849,5.6162225L7.79162,5.6162225L7.66008,4.3105625L5.17002,4.3105625Z'
          fill='#333333'
          fillOpacity='1'
        />
      </g>
    </g>
  </svg>
)

export default SvgLinkedin
